__turbopack_context__.v({
  "card-personal-page": "layout-module-scss-module__kl-G-W__card-personal-page",
  "card-personal-setting": "layout-module-scss-module__kl-G-W__card-personal-setting",
  "card-personal-setting-explainer": "layout-module-scss-module__kl-G-W__card-personal-setting-explainer",
  "card-personal-setting-name": "layout-module-scss-module__kl-G-W__card-personal-setting-name",
  "card-personal-setting-toggle-container": "layout-module-scss-module__kl-G-W__card-personal-setting-toggle-container",
  "card-personal-settings": "layout-module-scss-module__kl-G-W__card-personal-settings",
  "card-personal-settings-heading": "layout-module-scss-module__kl-G-W__card-personal-settings-heading",
  "finish-setup-desktop": "layout-module-scss-module__kl-G-W__finish-setup-desktop",
  "finish-setup-tablet": "layout-module-scss-module__kl-G-W__finish-setup-tablet",
  "main-content": "layout-module-scss-module__kl-G-W__main-content",
  "tabs-container": "layout-module-scss-module__kl-G-W__tabs-container",
});
